<template>
    <div class="page-container form-columns-fit" style="height: 100%; display: table;">
        <div class="vertical-flow">
            
            <ul class="nav nav-tabs nav-tabs-children" v-show="exibirAbas">
                <li
                    v-for="(aba, i) in abas"
                    :key="i"
                    :class="{ active: abaSelecionada == i }"
                    @click="changeTab(i)"
                >
                    <a data-toggle="tab">{{ $t(aba) }}</a>
                </li>
            </ul>
            
            <b-dropdown aria-role="list" class="mobile-tab-list">
                <div slot="trigger" class="mobile-tab">
                    <span class="mobile-tab-text">
                        {{ $t(abas[abaSelecionada]) }}
                    </span>
                    <em class="mdi mdi-chevron-down"></em>
                </div>

                <b-dropdown-item
                    class="mobile-tab-list-item"
                    :class="{ active: abaSelecionada == i }"
                    aria-role="listitem"
                    v-for="(aba, i) in abas"
                    :key="i"
                    @click="changeTab(i)"
                >
                    {{ $t(aba) }}
                </b-dropdown-item>
            </b-dropdown>

            <!-- MODAL DE ASSOCIACAO -->
            <SaldoProduto
                ref="saldoprodutoAba"
                v-if="abasAbertas['saldoproduto']"
                v-show="abas[abaSelecionada] == 'saldoproduto'"
                @emEdicao="emEdicao"
            />
            <SaldoGrade
                ref="saldoprodutoAba"
                v-if="abasAbertas['saldograde']"
                v-show="abas[abaSelecionada] == 'saldograde'"
                @emEdicao="emEdicao"
            />
            <SaldoRemessa
                ref="saldoprodutoAba"
                v-if="abasAbertas['saldoremessa']"
                v-show="abas[abaSelecionada] == 'saldoremessa'"
                @emEdicao="emEdicao"
            />
        </div>
    </div>
</template>

<script>
import SaldoProduto from "@/components/vendas/produto/modal/dados-cadastrais/saldo/SaldoProduto.vue";
import SaldoGrade from "@/components/vendas/produto/modal/dados-cadastrais/saldo/SaldoGrade.vue";
import SaldoRemessa from "@/components/vendas/produto/modal/dados-cadastrais/saldo/SaldoRemessa.vue";

export default {
    beforeRouteLeave(to, from, next) {
        if (this.isChanged) {
            this.promptChangeTab(next);
        } else {
            next();
        }
    },
    components: {
        SaldoProduto,
        SaldoRemessa,
        SaldoGrade,
    },
    data() {
        return {
            integracao:
                this.$store.state.user.tabelasERPWebServer.includes("SALDOPRODUTO"),
            permissao: false,
            delete: null,
            abaSelecionada: 0,
            abas: [
                "saldoproduto",
                "saldograde",
                "saldoremessa",
            ],
            abasAbertas: {},
            isChanged: false,
            exibirAbas: true,
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess(
            "vendas",
            "produtos",
            "ven-produto-dados-cadastrais-saldo"
        );

        if (!this.permissao.read) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "saldo" },
            });
        } else {
            // Criação dinâmica de abasAbertas baseado no nome das tabs
            for (let [key, value] of Object.entries(this.abas)) {
                this.abasAbertas[value] = false;
            }

            // Pegar dinâmicamente a primeira aba que estivar com permissão de leitura para a mesma iciciar visível
            for (let [key, value] of Object.entries(this.abasAbertas)) {
                if (value.read) {
                    this.abaSelecionada = this.abas.findIndex((e) => e == key);
                    this.abasAbertas[key] = true;
                    break;
                }
            }
            this.changeTab(this.abaSelecionada)
        }
    },
    methods: {
        promptChangeTab(next) {
            this.$root.confirm({
                message: this.$t("msg-tem-certeza-alteracoes"),
                onConfirm: (_) => {
                    this.isChanged = false;
                    next();
                },
                onCancel: (_) => {
                    next(false);
                },
            });
        },
        changeTab(i) {
            this.abaSelecionada = i;
            this.abasAbertas[this.abas[this.abaSelecionada]] = true;
        },
        emEdicao(){
            this.exibirAbas = !this.exibirAbas
        }
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;

        .nav-tabs-main {
            margin-bottom: 10px;
        }
        .nav-tabs-children {
            margin-bottom: 20px;
            li > a {
                text-transform: capitalize;
            }
            li > ::after {
                bottom: -4px;
                border-width: 2px;
            }
        }

        .mobile-tab {
            cursor: pointer;

            &-list {
                width: calc(100% + 40px);
                margin-top: 20px;
                margin-bottom: 20px;
                margin-left: -20px;
                padding-right: 20px;
                padding-bottom: 5px;
                padding-left: 20px;
                border-bottom: 1px solid $table-border;
                justify-content: center;

                &::after {
                    content: "";
                    border: 3px solid $primary-color-click;
                    border-radius: 100px;
                    position: absolute;
                    width: calc(100% - 40px);
                    bottom: -3px;
                }

                &-item {
                    text-transform: uppercase;
                    font-weight: 600;
                    color: $text-color;

                    &.active {
                        color: $primary-color-click;
                    }
                }
            }

            &-text {
                text-transform: uppercase;
                font-weight: 600;
                color: $primary-color-click;

                & ~ i {
                    color: $primary-color-click;
                }
            }
        }
    }
}

@media only screen and (max-width: 760px) {
    .nav.nav-tabs-main {
        display: flex;
        justify-content: center;
        padding: 0;
        margin: 0;

        &::after {
            display: none;
        }
    }

    .nav.nav-tabs.nav-tabs-children {
        display: none;
    }
}

@media only screen and (min-width: 761px) {
    .mobile-tab-list {
        display: none;
    }
}
</style>